import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCGrid, RCCHookToast, RCCInput, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import { useForm } from "react-hook-form";
import DeleteModal from "src/components/DeleteModal";
import { useTranslation } from "src/context/Translations/context";
import { getValidationErrors, standardErrorMessages } from "src/utils/errors";
import { IComponentOccurrenceModal, IOccurrence, IRefModalDelete } from "../interface";
import { deleteSchema } from "../schemas";


const ModalDelete: React.ForwardRefRenderFunction<IRefModalDelete, IComponentOccurrenceModal> = ({
	onCallbackDelete
}, ref) => {

	const {translate} = useTranslation();
	const [selectedOccurence, setSelectedOccurence] = useState<IOccurrence>();
	const { addToast } = RCCHookToast();

	// Modal delete
	const modalDelete = useRef<RCCRefModalProps>(null); 
	const { handleSubmit: handleSubmitDelete, register: registerDelete, reset : resetDelete, setError : setErrorDelete, formState: { errors : errorsDelete }, clearErrors: clearErrorsDelete } = useForm();

	useImperativeHandle(ref, () => ({
		actionButtonDelete
	}));

	const actionButtonDelete = (row: IOccurrence) => {
		resetDelete();
		setSelectedOccurence(row);
		modalDelete.current?.openModal();
	};

	const submitDelete = async (data: any) => {
		try{
			clearErrorsDelete();	
			modalDelete.current?.setLoadingButton();

			await deleteSchema(translate).validate({...data, "ocb001TituloConfirmation": selectedOccurence?.ocb001Titulo},{
				abortEarly: false
			});
			
			await RCCServicesApi.deleteRequest({
				method: "Occurrences/Delete",
				urlParameters: {
					id: selectedOccurence?.ocb001Id,
					title: selectedOccurence?.ocb001Titulo
				}
			}); 

			if(onCallbackDelete)
				onCallbackDelete(selectedOccurence?.ocb001Id);

			addToast({
				color: "green",
				description: translate("Ocorrência excluída com sucesso"),
				title: translate("Sucesso")
			});
			modalDelete.current?.resetLoadingButton();
			modalDelete.current?.closeModal();

			if(onCallbackDelete)
				onCallbackDelete(selectedOccurence?.ocb001Id);

		}catch(err){
			modalDelete.current?.resetLoadingButton();
			if(getValidationErrors(err, setErrorDelete))
				return;
			standardErrorMessages(err, "Erro ao excluir ocorrência", addToast);
		}
		
	};

	return (
		<>
			<DeleteModal
				ref={modalDelete}
				title= {translate("Exclusão de Ocorrência")}
				description= {`${translate("Deseja realmente excluir a ocorrência")}: ${selectedOccurence?.ocb001Titulo}?`}
				onSubmit = {handleSubmitDelete(submitDelete)} 
				height="250px"
			>
				<RCCGrid
					container
					item
					xs={10}
				>
					<RCCInput 
						register={registerDelete}
						name="ocb001Titulo"
						label={translate("Digite o título da ocorrência para excluí-lo")}
						maxLength={200}
						error={errorsDelete.ocb001Titulo}
						required
					/>
				</RCCGrid>
			</DeleteModal>
		</>
	);
}
;


export default forwardRef(ModalDelete);
